/* Awesome-style theme interactions */
(function () {
  'use strict';

  // Mobile menu toggle
  var menuToggle = document.querySelector('.header__menu-toggle');
  var nav = document.querySelector('.header__nav');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  // Accordion (FAQ + ingredients)
  document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.accordion__item');
      var isOpen = item.classList.contains('open');
      // close siblings within same accordion
      var parent = item.parentElement;
      parent.querySelectorAll('.accordion__item.open').forEach(function (el) {
        if (el !== item) el.classList.remove('open');
      });
      item.classList.toggle('open', !isOpen);
    });
  });

  // Buy box: variant + plan selection
  document.querySelectorAll('[data-buybox]').forEach(function (box) {
    box.querySelectorAll('.buybox__variant').forEach(function (v) {
      v.addEventListener('click', function () {
        box.querySelectorAll('.buybox__variant').forEach(function (x) { x.classList.remove('active'); });
        v.classList.add('active');
      });
    });
    box.querySelectorAll('.buybox__plan').forEach(function (p) {
      p.addEventListener('click', function () {
        box.querySelectorAll('.buybox__plan').forEach(function (x) { x.classList.remove('active'); });
        p.classList.add('active');
      });
    });
    // Gallery thumbnail swap
    var mainImg = box.querySelector('.buybox__main-img img');
    box.querySelectorAll('.buybox__thumbs img').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) mainImg.src = thumb.dataset.full || thumb.src;
        box.querySelectorAll('.buybox__thumbs img').forEach(function (x) { x.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  });

  // Scroll reveal
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'none';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });
  }
})();
